import { useEffect, useState } from "react";
import { CustomerData } from "./useCustomerSearch";
import api from "../../../../../../features/auth/axiosConfig";

export interface OrderItem {
  Orderamount: number;
  Orderdate: string;
  Ordertime: string;
  ReceivedAmount: number;
  RemainingAmount: number;
  Total_price: number;
  cancel_amount: number;
  discount: number;
  order_status: string;
  orderid: string | null;
  payment_method: string;
}

export interface LedgerData {
  _id?: { $oid: string };
  OrderDetails: OrderItem[];
  customer_id: string;
  customer_name: string;
  customer_phone_number: string;
  total_outstanding_balance: string;
}

export const useLedger = (customer: CustomerData | null) => {
  const [ledger, setLedger] = useState<LedgerData | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customer) return;
    setLoading(true);

    api
      .get(`/pos/ledger/customer/${customer._id.$oid}`)
      .then((res) => {
        setLedger(res.data.ledger);
      })
      .catch(() => {
        setLedger({
          OrderDetails: [],
          customer_id: customer._id.$oid,
          customer_name: customer.Name,
          customer_phone_number: customer.phone_number,
          total_outstanding_balance: "0.00",
        });
      })
      .finally(() => setLoading(false));
  }, [customer]);

  return { ledger, loading };
};